/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query CustomerReadQuery($customerType: CUSTOMER_TYPE, $take: PositiveInt, $skip: Int, $search: String!, $filter: JSONObject) {
  CustomerRead(customerType: $customerType, take: $take, skip: $skip, search: $search, filter: $filter, returnDeliveriesOfTrunk: false) {
    id,
    createdAt,
    updatedAt,
    displayName,
    overDraftLimit,
    message,
    phone,
    rateEmail,
    status,
    country,
    supportEmail,
    type,
    _totalCount
    AccountManager {
      displayName
    }
    Company {
      referenceNumber
      displayName
      email
    }
    CustomerAccount {
      id,
      Rate {
          displayName
      }
      Route {
          displayName
      }
    }
    Credit {
      balance,
      limit,
      alertAmount
    }
    Billing {
      id
      alertAmount
      currency
      address
      period
      enableAutoInvoicing
      smsType
      email
    }
  }
}
`
